module.exports = __webpack_public_path__ + "static/media/image-cropper.c6bdee15.md";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/image-cropper.md
// module id = 380
// module chunks = 0